import { connect } from 'react-redux';
import DashboardPanel from '../../components/DashboardPanel';

import {
  fetchAllEventsForBranchDispatch,
  setCurrentBranchesRecordDispatch,
  openEditEventPanelDispatch,
  eventEditClickDispatch,
  fetchAllCourseRecordssForBranchDispatch,
  fetchAllCoursesForBranchDispatch,
  fetchAllAccidentsForBranchDispatch,
  openEditCoursePanelDispatch,
  courseEditClickDispatch,
  fetchAllHazardsForBranchDispatch,
  openHazardReviewPanelDispatch,
  hazardEditClickDispatch,
  fetchAllPersonnelsDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    events: state.events.eventsByBranch.items,
    courses: state.courses.coursesByBranch.items,
    accidents: state.accidents.accidentsByBranch.items,
    courseRecords: state.courses.courseRecordsByBranch.items,
    hazards: state.hazards.hazardsByBranch.itemsCopy
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllEventsForBranch: (branchId) => {
      dispatch(fetchAllEventsForBranchDispatch(branchId));
    },
    fetchAllPersonnels: (branchId) => {
      dispatch(fetchAllPersonnelsDispatch(branchId));
    },
    fetchAllCourseRecordssForBranch: (branchId) => {
      dispatch(fetchAllCourseRecordssForBranchDispatch(branchId));
    },
    fetchAllCoursesForBranch: (branchId) => {
      dispatch(fetchAllCoursesForBranchDispatch(branchId));
    },
    fetchAllAccidentsForBranch: (branchId) => {
      dispatch(fetchAllAccidentsForBranchDispatch(branchId));
    },
    setCurrentBranchesRecord: (recordType) => {
      dispatch(setCurrentBranchesRecordDispatch(recordType));
    },
    handleEventRecordEditClick: (event) => {
      dispatch(openEditEventPanelDispatch(true));
      dispatch(eventEditClickDispatch(event));
    },
    handleCourseRecordEditClick: (course) => {
      dispatch(openEditCoursePanelDispatch(true));
      dispatch(courseEditClickDispatch(course));
    },
    fetchAllHazardsForBranch: (branchId) => {
      dispatch(fetchAllHazardsForBranchDispatch(branchId));
    },
    handleHazardItemEditClick: (item) => {
      dispatch(openHazardReviewPanelDispatch(true));
      dispatch(hazardEditClickDispatch(item));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPanel);
